import { render, staticRenderFns } from "./PartyContacts.vue?vue&type=template&id=3310ab2e&scoped=true&lang=pug"
import script from "./PartyContacts.vue?vue&type=script&lang=js"
export * from "./PartyContacts.vue?vue&type=script&lang=js"
import style0 from "./PartyContacts.vue?vue&type=style&index=0&id=3310ab2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3310ab2e",
  null
  
)

export default component.exports